import { render, staticRenderFns } from "./NoAuth.vue?vue&type=template&id=084c7c6c&scoped=true"
import script from "./NoAuth.vue?vue&type=script&lang=js"
export * from "./NoAuth.vue?vue&type=script&lang=js"
import style0 from "./NoAuth.vue?vue&type=style&index=0&id=084c7c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c7c6c",
  null
  
)

export default component.exports